// extracted by mini-css-extract-plugin
export var blue = "_2x-f";
export var brand = "_2x-b";
export var darkGrey = "_2x-e";
export var disabled = "_2x-4";
export var disabledSubtle = "_2x-5";
export var error = "_2x-6";
export var green = "_2x-g";
export var grey = "_2x-d";
export var icon = "_2x-0";
export var inherit = "_2x-a";
export var lightGrey = "_2x-c";
export var orange = "_2x-i";
export var pink = "_2x-k";
export var primary = "_2x-1";
export var purple = "_2x-l";
export var red = "_2x-j";
export var secondary = "_2x-2";
export var success = "_2x-9";
export var tertiary = "_2x-3";
export var warning = "_2x-7";
export var warningSecondary = "_2x-8";
export var white = "_2x-m";
export var yellow = "_2x-h";